import styled from 'styled-components';
import { motion } from 'framer-motion';

export default styled(motion.div)(() => ['position: absolute;', 'width: 100%;']);
